import { PortfolioCodeAssignmentResource } from 'app/_resources/portfolio-code.resource';
import { FileService } from 'app/_services/file.service';
import * as angular from 'angular';
import { mgoAngularWizard, PortfolioCodeUploadWizardContext } from '../custom';

class PortfolioCodeUploadWizardSummaryComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<PortfolioCodeUploadWizardContext>;
    private portfolioCodesSummary: PortfolioCodeAssignmentDto[];

    constructor(
        private portfolioCodeAssignmentResource: PortfolioCodeAssignmentResource,
        private fileService: FileService
    ) {}

    $onInit(): void {
        this.updateSummary();
    }

    public submit(): boolean {
        this.addCurrentToPortfolioCodesToSubmit();

        this.portfolioCodeAssignmentResource.save(
            {
                portfolioCodeAssignments:
                    this.wizardCtrl.context.portfolioCodesToSubmit
            },
            (res: FallbackUploadResponseDto) => {
                this.wizardCtrl.context.successMessage =
                    'The portfolio code upload succeeded.';
                this.wizardCtrl.context.errorMessage = null;
                this.wizardCtrl.context.portfolioCodesToSubmit = [];
                this.wizardCtrl.finish();
            },
            (err) => {
                this.wizardCtrl.context.successMessage = null;
                this.wizardCtrl.context.errorMessage =
                    'The portfolio code upload has failed.';
                this.wizardCtrl.context.portfolioCodesToSubmit = [];
            }
        );

        return true;
    }

    public removePortfolioCode(portfolioCode: PortfolioCodeAssignmentDto) {
        if (
            angular.equals(
                portfolioCode,
                this.wizardCtrl.context.currentPortfolioCode
            )
        ) {
            this.resetCurrentPortfolioCodeContext();
            this.updateSummary();
        } else {
            this.wizardCtrl.context.portfolioCodesToSubmit.splice(
                this.wizardCtrl.context.portfolioCodesToSubmit.indexOf(
                    portfolioCode
                ),
                1
            );
            this.updateSummary();
        }

        if (!this.portfolioCodesSummary.length) {
            this.wizardCtrl.reset();
            this.wizardCtrl.goTo(0);
        }
    }

    public editPortfolioCode(portfolioCode: PortfolioCodeAssignmentDto) {
        if (
            angular.equals(
                portfolioCode,
                this.wizardCtrl.context.currentPortfolioCode
            )
        ) {
            this.wizardCtrl.goTo(0);
            return;
        }

        this.addCurrentToPortfolioCodesToSubmit();

        const portfolioCodeToEdit =
            this.wizardCtrl.context.portfolioCodesToSubmit.splice(
                this.wizardCtrl.context.portfolioCodesToSubmit.indexOf(
                    portfolioCode
                ),
                1
            );
        this.resetCurrentPortfolioCodeContext();
        this.wizardCtrl.context.currentPortfolioCode = portfolioCodeToEdit[0];
        this.wizardCtrl.goTo(0);
    }

    public addNewPortfolioCode(): void {
        this.addCurrentToPortfolioCodesToSubmit();
        this.resetCurrentPortfolioCodeContext();
        this.wizardCtrl.goTo(0);
    }

    private updateSummary() {
        this.portfolioCodesSummary = [
            this.wizardCtrl.context.currentPortfolioCode,
            ...this.wizardCtrl.context.portfolioCodesToSubmit
        ].filter((value) => !!value);
    }

    private resetCurrentPortfolioCodeContext() {
        this.wizardCtrl.context.currentPortfolioCode = null;
        this.wizardCtrl.context.selectedShippers = [];
        this.wizardCtrl.context.unselectedShippers = angular.copy(
            this.wizardCtrl.context.shippersWithAssignmentToTso
        );
    }

    private addCurrentToPortfolioCodesToSubmit() {
        if (!this.wizardCtrl.context.portfolioCodesToSubmit) {
            this.wizardCtrl.context.portfolioCodesToSubmit = [];
        }

        this.wizardCtrl.context.portfolioCodesToSubmit.push(
            this.wizardCtrl.context.currentPortfolioCode
        );
    }

    public getShipperNameByShipperIdentifier(
        shipperIdentifier: CompanyIdDto
    ): string {
        const tsoShipperAssignmentsDto =
            this.wizardCtrl.context.shippersWithAssignmentToTso.find(
                (shipperWithAssignmentToTso: TsoShipperAssignmentsDto) =>
                    shipperWithAssignmentToTso.eic === shipperIdentifier.id
            );
        return tsoShipperAssignmentsDto.shipperName;
    }

    public restartWizard() {
        this.wizardCtrl.reset();
        this.resetCurrentPortfolioCodeContext();
        this.wizardCtrl.context.portfolioCodesToSubmit = [];
        this.wizardCtrl.context.errorMessage = null;
        this.wizardCtrl.context.successMessage = null;
    }

    public downloadXml() {
        this.portfolioCodeAssignmentResource.generateXml(
            { portfolioCodeAssignments: this.portfolioCodesSummary },
            (res: FallbackUploadResponseDto) => {
                this.fileService.triggerFileDownload(
                    res.responseXml,
                    'upload',
                    'text/xml'
                );
            },
            (err) => {
                this.wizardCtrl.context.errorMessage =
                    'The XML download has failed.';
            }
        );
    }
}

angular.module('app').component('pkpPortfolioCodeUploadWizardSummary', {
    controller: PortfolioCodeUploadWizardSummaryComponentCtrl,
    template:
        require('app/portfolio-code-upload-wizard/portfolio-code-upload-wizard-summary.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
